import Axios, {AxiosRequestHeaders} from 'axios'
import {ACCESS_TOKEN_KEY, REFRESH_TOKEN_KEY} from 'sr/constants/common'
import {getCookieValue, setCookieValue} from '../helper'
import { deleteCookies } from 'sr/helpers/functions/deleteCookies'

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
})



console.log('Base url :- ', process.env.REACT_APP_API_URL)

// axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*'
axios.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use(
  async (config) => {
    const copy = {...config}

    if (typeof localStorage !== 'undefined') {
      const accessToken = getCookieValue(ACCESS_TOKEN_KEY)
      if (accessToken && copy.headers) {
        ;(copy.headers as AxiosRequestHeaders).Authorization = `Bearer ${accessToken}`
      }
    }

    // ;(copy.headers as AxiosRequestHeaders).Authorization = `Bearer ${accessToken}`

    return config
  },
  async (error) => Promise.reject(error)
)

axios.interceptors.response.use(
  async (response) => {
   if (response.data.error == null) {
      return response
    }
    return Promise.reject(response)
  },

  async (error) => {

    const originalRequest = error.config;
    const isRefreshRequest = originalRequest.url.includes('/auth/refreshjwt');

if (error.response?.status === 401 && !originalRequest._retry && !isRefreshRequest) {
originalRequest._retry = true;
try {
  const refreshToken = getCookieValue(REFRESH_TOKEN_KEY);

const res = await axios.get(`/auth/refreshjwt`,{ headers: {
        Authorization: `Bearer ${refreshToken}`
      }
    }
)
if(res?.data?.jwt){
  const hours = 24; // Set the expiration time in hours
  const date = new Date();
  setCookieValue(ACCESS_TOKEN_KEY, res?.data?.jwt, date.getTime() + hours * 60 * 60 * 1000);
  originalRequest.headers.Authorization = `Bearer ${res?.data?.jwt}`;
return axios(originalRequest);
}
else {
deleteCookies(REFRESH_TOKEN_KEY);
deleteCookies(ACCESS_TOKEN_KEY);
    window.location.href = '/auth'; // Redirect to login
  return Promise.reject(error);
}
}
catch(err){
deleteCookies(REFRESH_TOKEN_KEY);
deleteCookies(ACCESS_TOKEN_KEY);
   window.location.href = '/auth'; // Redirect to login
  return Promise.reject(error);

}

}

    if (error.response && error.response.status >= 400) {
      console.error("Bad Request Error:");
      console.error("Response data:", error.response.data);
      console.error("Response headers:", error.response.headers);
      return Promise.reject(error);
    }
    return Promise.reject(error);
  }

)


export default axios
